<app-header [class.hidden]="screenHandlerService.isModalPage()" />
<main class="px-base container mx-auto min-h-80" id="content" [tabindex]="0">
  <app-notices />
  <router-outlet />
</main>
<div class="mt-[8rem]">
  <desy-footer />
</div>
